import React from 'react';
import Cookies from 'universal-cookie';
import db from './db';
import Dropdown from 'react-dropdown';
var functions = require("./functions.js");

// SQLEditor Component
function SQLEditor(props){

    // default Cookies
    const cookies = new Cookies();

    // defaultMaxCol
    let defaultMaxCol=cookies.get('sql-editor-max-column-display-length');
    if(!defaultMaxCol){
        defaultMaxCol="40";
    }
    
    // defaultSQL
    let defaultSQL=cookies.get('sql-editor-query');
    if(!defaultSQL){
        defaultSQL="select * from hub";
    }

    // defaultClearResults
    let defaultClearResults=cookies.get('sql-editor-clear-results-before-query')==="Y";
    
    // defaultPrefix
    let defaultPrefix=cookies.get('sql-editor-download-prefix');
    if(!defaultPrefix){
        defaultPrefix="WaveDownload";
    }
     
    let fileExtension="txt";
    return(true) ? (
        <div className="sql-editor-div">
            <div className="sql-editor-menu">
                <button onClick={runSQL} className="__nofocus" tabIndex="-1">Run(F4)</button>&nbsp;&nbsp;
                <button onClick={clearResults} className="__nofocus" tabIndex="-1">Clear Results</button>&nbsp;&nbsp;

                &nbsp;Maximum Column Width:&nbsp;
                <input type="number" defaultValue={defaultMaxCol} id="sql-editor-max-column-display-length" className="sql-editor-max-column-display-length"></input>&nbsp;&nbsp;

                &nbsp;Clear Results Before Each Query:&nbsp;
                <input type="checkbox" defaultChecked={defaultClearResults
                
                } defaultValue={defaultMaxCol} id="sql-editor-clear-results-before-query" className="sql-editor-clear-results-before-query"></input>&nbsp;&nbsp;

                Output Type:&nbsp;
                <input type="radio" id="sql-editor-output-type_txt" defaultChecked value="txt" name="sql-editor-output-type" className="sql-editor-output-type" />Text&nbsp;
                <input type="radio" id="sql-editor-output-type_csv" value="csv" name="sql-editor-output-type" className="sql-editor-output-type" />CSV&nbsp;
                <input type="radio" id="sql-editor-output-type_json" value="json" name="sql-editor-output-type" className="sql-editor-output-type" />JSON&nbsp;
            </div>
            <h3>Query  
                <Dropdown
                    id="sql report" 
                    value={JSON.parse(props.securityObject.systemSettings.sql_reports )[0].value}
                    onChange={updateReport.bind(this)}
                    options={JSON.parse(props.securityObject.systemSettings.sql_reports )} 
                    placeholder="Select Report" 
                />
            </h3>
            <textarea 
                id="sql-editor-query"  
                className="sql-editor-editor" 
                defaultValue={defaultSQL}
                onKeyUp={inputFilterKeyUp.bind(this)}
                disabled={!props.securityObject.isSuperUser} 
            ></textarea>
            <h3>
                Query Results 
                &nbsp;&nbsp;&nbsp;&nbsp;
                <small className='align-right'>
                    Download File Prefix:
                    &nbsp;
                    <input id="sql-editor-download-prefix" className="sql-editor-download-prefix" defaultValue={defaultPrefix}></input>
                    &nbsp;&nbsp;
                    <button onClick={downloadResult}>download</button>
                </small>
            </h3>
            <textarea id="sql-editor-result" className="sql-editor-viewer" ></textarea>
        </div>
    ) :"";


    // save cookies
    function saveCookies(){
        let defaultMaxCol = document.getElementById('sql-editor-max-column-display-length').value;
        cookies.set('sql-editor-max-column-display-length', defaultMaxCol);   

        let defaultSQL=document.getElementById('sql-editor-query').value;
        cookies.set('sql-editor-query', defaultSQL);        

        let defaultClearResults="N";
        if(document.getElementById('sql-editor-clear-results-before-query').checked){
            defaultClearResults="Y"
        }
        cookies.set('sql-editor-clear-results-before-query',defaultClearResults ); 

        let defaultPrefix=document.getElementById('sql-editor-download-prefix').value;
        cookies.set('sql-editor-download-prefix', defaultPrefix); 
    }
    function runSQL(){

        // save cookies
        saveCookies();

        // clear screen
        let resultTextArea=document.getElementById("sql-editor-result");
        let defaultClearResults=document.getElementById('sql-editor-clear-results-before-query').checked;
        let pos = resultTextArea.scrollHeight;
        if(resultTextArea.value===""){
            pos=0;
        }
        if(defaultClearResults){
            resultTextArea.value="";    
        }

        // run sql and save
        let sql={ sql:document.getElementById("sql-editor-query").value};
        db.saveData( 
            props.securityObject
            , sql
            ,"api/sql"
            // if successful add results and position
            , function(res){
                let resultString=getResultsForViewer(sql.sql, res.resultObject);
                resultTextArea.value+=resultString+"\n";
                resultTextArea.scrollTop = pos;
            },
            // if fail add notes and position
            function(res){
                resultTextArea.value+=res.resultMessage+"\n";
                if(pos!==0){
                    resultTextArea.scrollTop = pos;
                }
            }
        );

    }

    // get the results for viewer
    function getResultsForViewer(sql, resultObject){

        let result="";
        
        // if result is json file format
        if(document.getElementById("sql-editor-output-type_json").checked){
            result+=sql+"\n";
            result+=JSON.stringify(resultObject,null,2)
            fileExtension="json";
        // if not json format
        } else {

            // process array of query results
            try {

                // if there are no resulst do nothing
                if(resultObject.length===0){
                    result+="No results found";
                // if multiple results add each one
                } else if(resultObject[0][0]){
                    let cmds=sql.split(";");
                    let i=0;
                    resultObject.forEach( oneQueryResult=>{
                        result+="\n"+cmds[i]+";\n\n";
                        result += processOneQueryResult(oneQueryResult);
                        i++;
                    })
                // if only one result then just add that one
                } else {
                    result+="\n"+sql+"\n";
                    result += processOneQueryResult(resultObject);
                }

            } catch (e){
                window.alert(e);
            }

        }
        return result;
    }

    // get the results from just one query
    function processOneQueryResult(oneQueryResult){

        let result="";
        let maxLen=document.getElementById("sql-editor-max-column-display-length").value;

        // create all columns
        let columns={};

        // go thru all data to look for column names
        oneQueryResult.forEach( row =>{
            //row.forEach( col =>{
                Object.keys(row).map((columnName) => {

                    // if column does not exist then add it
                    if(!columns[columnName]){
                        columns[columnName]={length:columnName.length}
                    }

                    // calculate correct length
                    let len=14;
                    if((typeof row[columnName])==="string"){
                        len = row[columnName].length;
                    }
                    if(len>maxLen){
                        len=maxLen;
                    }
                    if(len>columns[columnName].length){
                        columns[columnName].length=len;
                    }
                    return columns[columnName];
                });
            //})
        });

        // print header
        let isCSV=document.getElementById("sql-editor-output-type_csv").checked;
        let spaceBetweenColumns="  ";

        let line2="";
        Object.keys(columns).map((columnName) => {
            if(isCSV){
                result+='"'+columnName+'",';    
                fileExtension="csv";
            } else {
                result+=columnName.padEnd( columns[columnName].length," ")+spaceBetweenColumns;
                line2+=" ".padEnd( columns[columnName].length,"-")+spaceBetweenColumns;
                fileExtension="txt";
            }
            return columnName;
        })
        result+="\n"
        if(!isCSV){
            result+=line2+"\n";
        }

        // print each row of data
        try {
            oneQueryResult.forEach( row =>{
            
                // print each object
                Object.keys(row).map((columnName) => {
                    let val=row[columnName];
                    if(!val){
                        val="";
                    } else if ((typeof val)==="number"){
                        val=val.toString();
                        val.padStart( columns[columnName].length," ")
                    }
                    if(isCSV){
                        val=val.replaceAll("\n",'\\n');
                        result+='"'+val+'",'; 
                    } else if(val.length>columns[columnName].length){
                        result+=val.substring( 0, columns[columnName].length)+spaceBetweenColumns;
                    } else {
                        result+=val.padEnd( columns[columnName].length," ")+spaceBetweenColumns;
                    }
                    return columnName;
                })
                result+="\n";
            });
            result+="\n"
            +"Record Count:"+oneQueryResult.length;            
        } catch(e){
            result=JSON.stringify(oneQueryResult,null,2);
        }

        return result;
    }

    //clear the results
    function clearResults(){
        let resultTextArea=document.getElementById("sql-editor-result");
        resultTextArea.value="";
    }

    // download results
    function downloadResult(){

        // save cookies
        saveCookies();

        // download file
        let resultTextArea=document.getElementById("sql-editor-result");
        let filePrefix=document.getElementById("sql-editor-download-prefix");
        ///let ext = document.getElementById('sql-editor-output-type').value;
        //let ext = $("input[type='radio'][name='sql-editor-output-type']:checked").val();
        functions.downloadFile( filePrefix.value
                                ,resultTextArea.value
                                , fileExtension );
    }
    function inputFilterKeyUp(event) {
        // 115 is F4
        if (event.keyCode === 115) {
          event.preventDefault();
          runSQL();
        }
    }
    function updateReport(option){
        document.getElementById("sql-editor-query").value=option.value;
    }
}
export default SQLEditor;